import axios from 'axios'
export async function getToken() {
    return new Promise((resovle, reject) => {
        SmartCity.getUserInfo(function (res) {
            if (res && res.userInfo) {
                resovle(res.userInfo.userTokenKey)
            } else {
                SmartCity.goLogin()
            }
        })
    })
}

export async function getM2oId() {
    return new Promise((resovle, reject) => {
        SmartCity.getUserInfo(function (res) {
            if (res && res.userInfo) {
                resovle(res.userInfo.userid)
            } else {
                SmartCity.goLogin()
            }
        })
    })
}

export async function getDeviceToken() {
    return new Promise((resovle, reject) => {
        SmartCity.getSystemInfo(function (res) {
            if (res && res.deviceInfo) {
                resovle(res.deviceInfo.device_token)
            } else {
                SmartCity.goLogin()
            }
        })
    })
}

export async function checkLocation(){
    return new Promise((resovle, reject) => {
        SmartCity.getLocation(function (res) {
            console.log('res: ', res);
            if(typeof res.latitude !== "undefined"){
                res.area = res.area.toLocaleLowerCase();
                if(res.area.indexOf('南浔') > -1 || res.area.indexOf('nanxun') > -1){
                // if(res.area.indexOf('吴兴') > -1 || res.area.indexOf('wuxing') > -1){
                    resovle(true);
                }else{
                    resovle(false);
                }
            }
        })
    })
}

export async function checkWuxing(){
    return new Promise((resovle, reject) => {
        SmartCity.getLocation(function (res) {
            console.log('res: ', res);
            if(typeof res.latitude !== "undefined"){
                res.area = res.area.toLocaleLowerCase();
                if(res.area.indexOf('吴兴') > -1 || res.area.indexOf('wuxing') > -1){
                    resovle(true);
                }else{
                    resovle(false);
                }
            }
        })
    })
}

export async function checkHuzhou(){
    return new Promise((resovle, reject) => {
        SmartCity.getLocation(function (res) {
            console.log('res: ', res);
            if(typeof res.latitude !== "undefined"){
                res.city = res.city.toLocaleLowerCase();
                if(res.city.indexOf('湖州') > -1 || res.city.indexOf('huzhou') > -1){
                    resovle(true);
                }else{
                    resovle(false);
                }
            }
        })
    })
}

export async function check() {
    let isSmartCityApp = SmartCity.isSmartCityApp()
    if (!isSmartCityApp) {
        window.location.href = 'http://share.plus.hugd.com/app/jump/2022/nthh2znzt'
    }
}

export async function wxShare(title, imgUrl) {
    let contentURL = window.location.href;
    const { data: res } = await axios.get(
        `https://nthhserve.hugd.com/pledgeManage/getWecatTicketAndSaveNew?url=${encodeURIComponent(window.location.href)}`
    )
    if (res.code == 200) {
        if (res.data) {
            let timestamp = res.data.timestamp
            let nonceStr = res.data.noncestr
            let signature = res.data.sign
            wx.config({
                debug: false,
                appId: 'wxc0ae0375c6f4a068', // 必填，公众号的唯一标识
                timestamp, // 必填，生成签名的时间戳
                nonceStr, // 必填，生成签名的随机串
                signature, // 必填，签名
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
            })
            if (process.env.NODE_ENV !== 'production'  || window.location.href.indexOf('_debug=jsdev') > -1) {
                wx.config({
                    debug: true,
                    appId: 'wxc0ae0375c6f4a068', // 必填，公众号的唯一标识
                    timestamp, // 必填，生成签名的时间戳
                    nonceStr, // 必填，生成签名的随机串
                    signature, // 必填，签名
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
                })
            }
            wx.ready(function () {
                wx.onMenuShareTimeline({
                    title,
                    link: contentURL, // 分享链接
                    imgUrl,
                })

                wx.onMenuShareAppMessage({
                    title,
                    desc: '', // 分享描述
                    link: contentURL, // 分享链接，该链接域名必须与当前企业的可信域名一致
                    imgUrl, // 分享图标
                    type: '', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                })
                wx.error(function (res) {
                    console.log('微信分享error', res)
                })
            })
        }
    }
}

